import { render } from "./Partners.vue?vue&type=template&id=c36bd432&scoped=true&ts=true"
import script from "./Partners.vue?vue&type=script&lang=ts"
export * from "./Partners.vue?vue&type=script&lang=ts"

import "./Partners.vue?vue&type=style&index=0&id=c36bd432&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36bd432"]])

export default __exports__